import { F0Button } from '@factorialco/f0-react'
import { Upload } from '@factorialco/f0-react/icons/app'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useFilters } from 'modules/shift_management/hooks/useFilters'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useUI } from 'modules/shift_management/hooks/useUI'

interface Props {
  onClick: (toggleModal: boolean) => void
}

const PublishButton = ({ onClick }: Props) => {
  const [{ view, conflictsCount, hasDrafts, hasDraftsWithoutConflict }] = useSchedule()
  const [{ isRefreshingStats }] = useUI()
  const [{ employeeIds, teamIds, customFilters, locationIds, withoutShiftIds }] = useFilters()

  const numberOfFilters =
    customFilters.length + (teamIds?.length ?? 0) + (employeeIds?.length ?? 0) + locationIds.length
  const filterByWithoutConflict = !!withoutShiftIds?.length

  let disableButton: boolean
  if (filterByWithoutConflict) {
    disableButton = !hasDraftsWithoutConflict || isRefreshingStats
  } else {
    disableButton = conflictsCount !== 0 || !hasDrafts || isRefreshingStats
  }

  const onClickButton = () => {
    track(trackingEvents.shiftManagement.publishShiftManagementStart, {
      view: view.viewType,
      view_type_by: view.groupType,
      number_of_filters: numberOfFilters,
    })
    onClick(true)
  }

  return (
    <F0Button
      label={i18n.t('shift_management.actions.publish_short')}
      onClick={() => onClickButton()}
      disabled={disableButton}
      icon={Upload}
    >
      {i18n.t('shift_management.actions.publish_short')}
    </F0Button>
  )
}

export default PublishButton
